/**
 * Shared display formatters. Keep format strings consistent across pages —
 * if CallHistoryPage renders dates one way and AccessKeysPage another, the
 * admin UI looks inconsistent for no good reason.
 */

/** `15 Apr 2026 13:42` — matches CallHistoryPage's historical format. */
export function formatDateTime(iso: string): string {
  const d = new Date(iso)
  return (
    d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) +
    ' ' +
    d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
  )
}

/** Short date only: `15 Apr 2026`. Used where a full timestamp is overkill. */
export function formatDate(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

/** `1:23` for >0 seconds, `—` for 0. Single source for CallHistoryPage,
 * the operator CallHistoryPanel, and any other duration cell. */
export function formatDuration(seconds: number): string {
  if (seconds === 0) return '—'
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m}:${s.toString().padStart(2, '0')}`
}
